import React from 'react';

export default function PHPStack() {
  return (
    <>
      <section className="container-wrapper">
    <h2>PHP - Full Stack</h2>
    <p>The PHP Full Stack Development program is designed to equip learners with the skills to build modern, scalable, and responsive web applications using <strong>PHP, MySQL, Code Igniter and Laravel</strong>. Starting with the fundamentals of HTML, CSS, Bootstrap and JavaScript learners progress through front-end development, back-end APIs, databases, and full-stack integration.</p>
  <p>This course blends <strong>theory, hands-on coding, and real-world projects</strong>, preparing participants to work confidently as full-stack developers.</p>

  <h2>Course Duration</h2>
  <h3>4 Months (16 Weeks)</h3>
  <ul className="course-desc">
    <li><strong>Mode:</strong> Online</li>
    <li><strong>Format:</strong> Lectures, Coding Tests, Assignments, and Projects</li>
    <li><strong>Pre-requisites:</strong> Basic computer knowledge, logical thinking. No prior coding experience required.</li>
  </ul>

    <h2 className='mt-30'>Learning Objectives</h2>
    <p>By the end of this course, participants will:</p>
    <ul className="course-list">
      <li>Understand web development fundamentals with <strong>HTML, CSS, and JavaScript</strong>.</li>
      <li>Build interactive and responsive front-end applications using <strong>HTML, CS, Bootstrap and JavaScript</strong>.</li>
      <li>Develop scalable back-end APIs with <strong>PHP and MySQL</strong>.</li>
      <li>Design and manage SQL databases with <strong>MySQL</strong>.</li>
      <li>Integrate front-end and back-end into <strong>full-stack applications</strong>.</li>
      <li>Work with <strong>Git, GitHub</strong>, and follow industry-standard development work flows.</li>
      <li>Deploy applications on cloud platforms <strong>(AWS, Github)</strong>.</li>
    </ul>

    <h3 className='mt-20'>Who Should Attend</h3>
    <ul className="course-list">
      <li>Beginners wanting to start a career in web development</li>
      <li>Students and graduates aiming for software jobs</li>
      <li>Professionals looking to upskill in full-stack development</li>
    </ul>

    <h3 className='mt-20'>Career Opportunities</h3>
    <p>After completing this course, learners can apply for roles such as:</p>
    <ul className="course-list">
      <li>Frontend Developer</li>
      <li>Backend Developer (PHP, MySQL, CodeIgniter and Laravel)</li>
      <li>Full Stack Developer (PHP Full Stack)</li>
    </ul>

    <h2 className='mt-30'>Course Modules</h2>
    <h3>Module 1: Web Fundamentals & PHP Basics (Week 1-2)</h3>
    <ul className="course-list">
      <li>Introduction to Web Development</li>
      <li>Client vs Server, HTTP, Web Server setup (XAMPP/WAMP)</li>
      <li>HTML5: Structure, Forms, Semantic Tags</li>
      <li>CSS3: Styling, Flexbox, Grid, Animations</li>
      <li>Responsive Web Design (Media Queries, Mobile-first Design)</li>
      <li>JavaScript Basics: Variables, Data Types, Functions, DOM Manipulation</li>
      <li>Bootstrap basics and 12 grid column system</li>
      <li>Responsive Web Design with Bootstrap</li>
      <li>Intro to PHP: syntax, variables, data types, operators</li>
      <li>Running PHP scripts, PHP in HTML</li>      
      <li>Mini Project: Portfolio Website</li>
    </ul>

    <h3 className='mt-20'>Module 2: Control Structures & Functions (Week 3)</h3>
    <ul className="course-list">
      <li>Conditional statements (if-else, switch)</li>
      <li>Loops (for, while, foreach)</li>
      <li>Arrays (indexed, associative, multidimensional)</li>
      <li>PHP Functions: user-defined, built-in, variable scope</li>
      <li>Form handling (GET & POST methods)</li>
    </ul>

    <h3 className='mt-20'>Module 3: Working with Files & Sessions (Week 4)</h3>
    <ul className="course-list">
      <li>File handling in PHP (read/write/upload)</li>
      <li>Handling images & file uploads securely</li>
      <li>Cookies & Sessions</li>
      <li>Working with superglobals ($_SERVER, $_FILES, $_SESSION)</li>
      <li>Include & require statements for reusable code</li>
    </ul>

    <h3 className='mt-20'>Module 4: MySQL & CRUD Applications with PHP (Week 5-8)</h3>
    <ul className="course-list">
      <li>Database, tables, primary/foreign keys</li>
      <li>CRUD in SQL (SELECT, INSERT, UPDATE, DELETE)</li>
      <li>Joins, WHERE clauses, basic aggregate functions</li>
      <li>Connecting PHP with MySQL (MySQLi / PDO)</li>
      <li>Executing queries, fetching data</li>
      <li>Error handling & prepared statements</li>
      <li>CRUD with PHP and MySQL</li>
      <li>Form validation with PHP and MySQL</li>
      <li>Authentication system (Login/Logout with sessions)</li>
      <li>Advanced MySQL features: Transaction, Stored Procedures and Functions</li>
      <li>Building REST API and test with postman</li>
      <li>Mini Project: Basic Blog CMS (Admin Panel + Post CRUD + Login)</li>
    </ul>

    <h3 className='mt-20'>Module 5: CodeIgniter Framework (Week 9 - 12)</h3>
    <ul className="course-list">
      <li>Introduction to CodeIgniter and MVC pattern</li>
      <li>Installing & setting up CodeIgniter</li>
      <li>Folder structure, configuration, routes</li>
      <li>Controllers, Views, Models – Basics</li>
      <li>URL routing</li>
      <li>Form handling in CodeIgniter</li>
      <li>Using helpers & libraries</li>
      <li>Database configuration and Active Record</li>
      <li>Building CRUD operations using MVC</li>
      <li>Form validation in CI</li>
      <li>Session & authentication in CI</li>
      <li>Working with templates (Header/Footer)</li>
      <li>Mini Project: Student Management System (CRUD + Auth + Dashboard)</li>
    </ul>


    <h3 className='mt-20'>Module 6: Laravel Framework (Week 13-16)</h3>
    <ul className="course-list">
      <li>Introduction to Laravel</li>
      <li>Installing & setting up Laravel</li>
      <li>Folder structure, configuration, Artisan CLI</li>
      <li>Routing, Controllers, Views (Blade templates)</li>
      <li>Environment setup (.env, artisan serve)</li>
      <li>Migrations, Seeders, Factories</li>
      <li>Eloquent models and relationships</li>
      <li>Form handling & Validation</li>
      <li>Authentication scaffolding</li>
      <li>API routes & JSON responses</li>
      <li>CRUD operations</li>
      <li>Git & GitHub (Version Control, Branching, Pull Requests)</li>
      <li>Deployment: AWS</li>
      <li>Final Project Presentation</li>
      <li>Aggregation Framework</li>
      <li>Mini Project: Product Catalog API with MySQL</li>
    </ul>    
  </section>
  </>
  );
}







